import type { FunctionComponent, ReactNode } from 'react';
import { useMemo } from 'react';
import type { Gender } from '../../../app/api/generated/client';
import FemaleDefault from '../gender-icons/female_default.svg?react';
import FemaleDisabled from '../gender-icons/female_disabled.svg?react';
import FemaleHover from '../gender-icons/female_hover.svg?react';
import MaleDefault from '../gender-icons/male_default.svg?react';
import MaleDisabled from '../gender-icons/male_disabled.svg?react';
import MaleHover from '../gender-icons/male_hover.svg?react';
import OtherDefault from '../gender-icons/other_default.svg?react';
import OtherDisabled from '../gender-icons/other_disabled.svg?react';
import OtherHover from '../gender-icons/other_hover.svg?react';

interface IGenderIconMapEntry {
    default: ReactNode;
    disabled: ReactNode;
    hover: ReactNode;
}

const genderIconMap: Record<Gender, IGenderIconMapEntry> = {
    ['FEMALE']: {
        default: <FemaleDefault />,
        disabled: <FemaleDisabled />,
        hover: <FemaleHover />,
    },
    ['MALE']: {
        default: <MaleDefault />,
        disabled: <MaleDisabled />,
        hover: <MaleHover />,
    },
    ['OTHER']: {
        default: <OtherDefault />,
        disabled: <OtherDisabled />,
        hover: <OtherHover />,
    },
};

interface IProps {
    gender?: Gender;
    isDisabled: boolean;
    isHovered: boolean;
}

export const GenderIcon: FunctionComponent<IProps> = ({ gender, isDisabled, isHovered }) => {
    const currentIcon = useMemo(() => {
        const resolvedGender = gender ?? 'OTHER';
        if (isDisabled) return genderIconMap[resolvedGender].disabled;

        return isHovered ? genderIconMap[resolvedGender].hover : genderIconMap[resolvedGender].default;
    }, [gender, isDisabled, isHovered]);

    return <>{currentIcon}</>;
};
